import React from 'react';
import PrometheusQueryChart, { PrometheusQueryChartProps } from "./PrometheusQueryChart";

export type PrometheusRangeQueryChartProps = PrometheusQueryChartProps

export default function PrometheusRangeQueryChart(props: PrometheusRangeQueryChartProps) {
    return <PrometheusQueryChart isRangeQuery {...props} />
}